module.exports = __webpack_public_path__ + "static/img/skm.22ee3d14.jpg";